import { useEffect, useState } from "react";
import { Accordion, Card, Col, Row, Spinner, useAccordionButton } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { AiFillCaretDown, AiFillCaretRight, AiOutlineBook, AiOutlineFile, AiOutlineFolder } from "react-icons/ai";
import { toast } from "react-toastify";
import { ButtonFavorite } from "../../../../../components/button-favorite";
import { FlatCardObject } from "../../../../../components/flat-card-object";
import { IMaterial } from "../../../../../models/IMaterial";
import { IObjectResponse } from "../../../../../models/IObjectResponse";
import { detailDiscipline } from "../../../../../services/discipline.service";
import { removeFavorite } from "../../../../../services/favorites.service";
import { Objects } from "../../../home/styles";
import { UnityAccordion } from "../unity-accordion";
import { CardButton, CardUnity, CardDescription } from "./styles";

function CustomToggle({ children, eventKey, activeEventKey }: any) {
    const decoratedOnClick = useAccordionButton(eventKey, () => {
        activeEventKey(eventKey);
    });

    return (
        <div onClick={decoratedOnClick}>
            {children}
        </div>
    );
}

export function DisciplineAccordion(props: any) {
    const {disciplines} = props
    const { t: translation } = useTranslation();

    const [discipline, setDiscipline] = useState<any>([])
    const [activeKey, setActiveKey] = useState<string>('')
    const [loading, setLoading] = useState<boolean>(false)

    const handleActiveCurrentKey = (key: any) => {
        if (activeKey === key) {
            setActiveKey('');
        } else {
            setActiveKey(key);
            getDisciplineDetails(key)
        }
    }

    const getDisciplineDetails = (id: any) => {
        setLoading(true)
        detailDiscipline(id).then((resp: any) => {
            setDiscipline(resp);
        }).finally(() => {
            setLoading(false)
        })
    }

    const handleRemoveFavorite = (id: number) => {
        removeFavorite(id).then(() => {
            toast.success('Material removido com sucesso!', {
                position: "bottom-center",
            })
        }).catch((err: any) => {
            toast.error('Ocorreu um erro ao remover este material.')
        })
    }

    return (
        <Accordion>
            {disciplines && disciplines.map(((material: any, index: string) => {
                return (
                    <Card className="mb-3" key={material.id} id={material.id}>
                        <CustomToggle eventKey={material.id} activeEventKey={handleActiveCurrentKey}>
                            <CardUnity>
                                <Row>
                                    <Col>{activeKey === material.id ? (<AiFillCaretDown></AiFillCaretDown>) : (<AiFillCaretRight></AiFillCaretRight>)} {material.title}</Col>
                                    <Col>
                                        <CardButton onClick={(event) => event.stopPropagation()}>
                                            <ButtonFavorite key={material.id} material={material} isMaterialView={false} variant="blueberry" materialType="Discipline" removeFavorite={handleRemoveFavorite} />
                                        </CardButton>
                                    </Col>
                                </Row>
                            </CardUnity>
                        </CustomToggle>
                        <Accordion.Collapse eventKey={material.id}>
                            <Card.Body>
                                {
                                    loading ? (
                                        <div className="loading-container mt-5">
                                            <Spinner animation="border" variant="primary" style={{ width: '2rem', height: '2rem', borderWidth: '0.25em', borderRightColor: 'transparent' }}/>
                                        </div>
                                    ) : (
                                        <>
                                            <Row>
                                                <Col>
                                                    <CardDescription>
                                                        <div className="title mb-2"><AiOutlineFile fontSize={20} style={{ marginTop: '-5px' }}></AiOutlineFile> {translation('material.menuDiscipline')}</div>
                                                        <div dangerouslySetInnerHTML={{ __html: discipline?.description || translation('userAccount.uninformed') }}></div>
                                                    </CardDescription>
                                                </Col>
                                            </Row>

                                            <Row className="mt-3">
                                                <Col>
                                                    <CardDescription>
                                                        <div className="title mb-3"><AiOutlineFolder fontSize={20} style={{ marginTop: '-5px' }}></AiOutlineFolder> {translation('material.units')}</div>
                                                        {(() => {
                                                            if (discipline?.items) {
                                                                return (
                                                                    <UnityAccordion key={discipline.id} unities={discipline?.items}></UnityAccordion>
                                                                )
                                                            }

                                                            return null;
                                                        })()}

                                                        {discipline?.items?.length === 0 ? (
                                                            <h6>{translation('notFound.discipline')}</h6>
                                                        ) : (
                                                            <></>
                                                        )}

                                                    </CardDescription>
                                                </Col>
                                            </Row>

                                            <Row className="mt-3">
                                                <Col>
                                                    <CardDescription>
                                                        <div className="title mb-3"><AiOutlineBook fontSize={20} style={{ marginTop: '-5px' }}></AiOutlineBook> {translation('material.bibliography')}</div>
                                                        <div dangerouslySetInnerHTML={{ __html: discipline?.reference || translation('userAccount.uninformed') }}></div>
                                                    </CardDescription>
                                                </Col>
                                            </Row>
                                        </>
                                    )
                                }
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                )
            }))}
        </Accordion>
    )
}